module.exports = __webpack_public_path__ + "static/media/zoe_huang.837ea8aa.jpg";